import React from "react";
import BlogCategory from './../../../Components/Blog/BlogOuter/Category/category';
import BlogList from "../../../Components/Blog/BlogOuter/BlogList/blogList";
import Footer from "../../../Components/Footer/footer";
const BlogOuter = () => {
  
  return (
      <>
        <BlogCategory/>
        <BlogList/>
      </>
  );
};

export default BlogOuter;
